export const PACKAGE_VERSION = '0.25.0'
